import MemberAccountWorkspace from "components/Member/MemberAccountWorkspace";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";
import Portfolio from "components/Portfolio/Portfolio";

export const accountRoutes = [
  {
    path: "/account",
    element: <RouteLayout />,
    children: [{ index: true, element: <Portfolio /> }],
    errorElement: <RouteErrorLayout errorTitle="Members" />,
  },
  {
    path: "/account/:member_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <MemberAccountWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Manage Account" />,
  },
];
